import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=203ac5a6&scoped=true&"
var script = {}
import style0 from "./banner.vue?vue&type=style&index=0&id=203ac5a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ac5a6",
  null
  
)

export default component.exports